import { render, staticRenderFns } from "./ClampedHtml.vue?vue&type=template&id=119f0cf0&scoped=true&"
import script from "./ClampedHtml.vue?vue&type=script&setup=true&lang=js&"
export * from "./ClampedHtml.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119f0cf0",
  null
  
)

export default component.exports